module.exports = __webpack_public_path__ + "static/img/img5.64c55a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img5.jpg
// module id = alUd
// module chunks = 1